var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDynIcon24CommentChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.91865 8.78812C6.32982 8.03446 5.35084 8.05404 5.204 8.30852C4.79283 9.01324 5.69348 9.19921 5.88928 8.83706M10.3632 8.77833C10.7744 8.02467 9.79538 8.04425 9.64854 8.29873C9.23737 9.00345 10.138 9.18942 10.3338 8.82727M14.8371 8.78812C15.2483 8.03446 14.2693 8.05404 14.1224 8.30852C13.7113 9.01324 14.6119 9.19921 14.8077 8.83706M12.6148 18.7717C12.6442 19.1338 12.6834 19.4666 12.7421 19.6917C13.0064 20.8663 13.4959 21.385 14.7 21.5318C15.5518 21.6297 17.265 21.5123 17.8621 21.7276C18.2537 21.8744 18.7824 23 19.174 23C19.7809 23 19.8494 22.2072 20.3096 21.7374C20.7697 21.2676 21.3277 21.3752 21.8074 21.1795C22.4731 20.9152 22.7178 20.3181 22.8647 19.3492C23.0115 18.3802 23.2465 14.6216 22.2675 13.9659C22.1598 13.8974 22.0228 13.8386 21.8563 13.7799M2.26708 1.85836C4.22502 0.58595 13.6134 1.0264 15.3755 1.31025C17.265 1.60388 18.704 2.59245 18.9292 4.7947C19.0369 5.89094 18.9879 9.99202 18.6257 11.5483C18.1656 13.545 17.3237 14.4161 15.2678 14.6608C13.8092 14.8272 10.8527 14.6314 9.83454 15.0034C9.15905 15.2481 8.2584 17.1469 7.5829 17.1567C6.5354 17.1665 6.41793 15.8158 5.63475 15.0229C4.85157 14.2301 3.89217 14.4063 3.05026 14.0735C1.90486 13.6331 1.49369 12.6249 1.23915 10.9708C0.984621 9.31666 0.563662 2.96438 2.26708 1.85836Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDynIcon24CommentChat);
export default __webpack_public_path__ + "static/media/dyn-icon-24-comment-chat.9bbeeaaa4720b98f5fd1d9b0f1cdfd37.svg";
export { ForwardRef as ReactComponent };